import React, { useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { Field, getIn, useFormikContext } from 'formik';
import { FormikInput } from '../../../../components';

export const addWithPrecision = (...numbers) => {
  const factor = 100;
  const result = numbers.reduce((sum, num) => {
    return sum + Math.round((num || 0) * factor);
  }, 0);
  return result / factor;
};

function HolidayCompensation({ viewOnly }) {
  const { values, errors, touched, setFieldValue } = useFormikContext();
  const legalVacationDays = +getIn(values, 'settlement[legalVacationDays]') || 0;
  const aditionalVacationDays = +getIn(values, 'settlement[aditionalVacationDays]') || 0;
  const progressiveVacationDays = +getIn(values, 'settlement[progressiveVacationDays]') || 0;
  const nonWorkingDays = +getIn(values, 'settlement[nonWorkingDays]') || 0;

  useEffect(() => {
    const totalDays = addWithPrecision(
      legalVacationDays,
      aditionalVacationDays,
      progressiveVacationDays,
      nonWorkingDays
    );
    setFieldValue('settlement[totalVacationDays]', totalDays.toFixed(2));
  }, [legalVacationDays, aditionalVacationDays, progressiveVacationDays, nonWorkingDays, setFieldValue]);

  return (
    <>
      <Row className="summary__balances_header small">
        <Col md={6} className="">
          <strong>Calculo de Días Feriados y Proporcional a Pagar</strong>
        </Col>
        <Col className="col-1 " />
      </Row>
      <Row>
        <Col xl={11} xs={12} className="d-flex p-0">
          <Col xl={3} md={3} lg={3} xs={12}>
            <Field name="settlement[legalVacationDays]">
              {({ field }) => (
                <FormikInput
                  {...field}
                  label="Vac. Legales"
                  value={values?.settlement?.legalVacationDays || ''}
                  error={getIn(errors, field.name)}
                  touched={getIn(touched, field.name)}
                  disabled={viewOnly}
                  style={{ minWidth: '65px' }}
                />
              )}
            </Field>
          </Col>
          <Col xl={3} md={3} lg={3} xs={12}>
            <Field name="settlement[aditionalVacationDays]">
              {({ field }) => (
                <FormikInput
                  {...field}
                  label="Adicionales"
                  value={values?.settlement?.aditionalVacationDays || ''}
                  error={getIn(errors, field.name)}
                  touched={getIn(touched, field.name)}
                  style={{ minWidth: '65px' }}
                  disabled={viewOnly}
                />
              )}
            </Field>
          </Col>
          <Col xl={3} md={3} lg={3} xs={12}>
            <Field name="settlement[progressiveVacationDays]">
              {({ field }) => (
                <FormikInput
                  {...field}
                  label="Progresivas"
                  value={values?.settlement?.progressiveVacationDays || ''}
                  error={getIn(errors, field.name)}
                  touched={getIn(touched, field.name)}
                  disabled={viewOnly}
                  style={{ minWidth: '65px' }}
                />
              )}
            </Field>
          </Col>
          <Col xl={3} md={3} lg={3} xs={12}>
            <Field name="settlement[nonWorkingDays]">
              {({ field }) => (
                <FormikInput
                  {...field}
                  label="Inhábiles"
                  value={values?.settlement?.nonWorkingDays || ''}
                  style={{ minWidth: '65px' }}
                  type="number"
                  disabled={viewOnly}
                  error={getIn(errors, field.name)}
                  touched={getIn(touched, field.name)}
                />
              )}
            </Field>
          </Col>
        </Col>
      </Row>
      <Row>
        <Col xl={11} xs={12} className="d-flex p-0">
          <Col xl={3} md={3} lg={3} xs={12}>
            <Field name="settlement[totalVacationDays]">
              {({ field }) => (
                <FormikInput
                  {...field}
                  label="Total"
                  error={getIn(errors, field.name)}
                  style={{ minWidth: '65px' }}
                  touched={getIn(touched, field.name)}
                  value={values?.settlement?.totalVacationDays || ''}
                  readOnly
                />
              )}
            </Field>
          </Col>
        </Col>
      </Row>
    </>
  );
}

export default HolidayCompensation;
